import '@styles/webdesktop/stylesheets/accountTypeLogo.scss';
import React from 'react';
import { Typography } from '../Typography/Typography';
import { TypographyLevel } from '../Typography/TypographyLevel';
import { Size } from '@front/sharedcomponents/Variables';
import { AccountSeal, getAccountSealLocalizationKey } from '@shared/commons/cache/AccountEnums';
import { Resources } from '@shared/localizations/Resources';
export const AccountTypeLogo = ({ accountType, size = Size.Medium }) => {
    const accountModeClasses = {
        [AccountSeal.Demo]: 'demo',
        [AccountSeal.Live]: 'live',
        [AccountSeal.Contest]: 'contest',
        [AccountSeal.Funded]: 'funded',
        [AccountSeal.Challenge]: 'challenge',
        [AccountSeal.Unspecified]: 'demo'
    };
    const accountModeClassNames = ['account-type-logo', size, accountModeClasses[accountType]];
    const accountModeClassName = accountModeClassNames.filter(Boolean).join(' ');
    return (React.createElement(Typography, { level: TypographyLevel.BodyXs, noWrap: true, className: accountModeClassName }, Resources.getResource(getAccountSealLocalizationKey(accountType))));
};
